import type { PriceItemType } from 'core/accounting/domain/PriceItemType'

import { useConfigContext } from 'config/ui/ConfigContext'

import { initialAccessorialRate, type AccessorialRate } from '../../domain/Accessorial'

export function useInitialAccessorialRate({
  accessorialType,
  priceItemType,
  accessorialRates,
}: {
  accessorialType?: number
  priceItemType?: PriceItemType
  accessorialRates: Array<AccessorialRate>
}) {
  const configs = useConfigContext()
  const enablePriceItemTypes = configs.enablePriceItemTypes.toBoolean()

  if (enablePriceItemTypes) {
    const accessorialRate = priceItemType
      ? accessorialRates.find(rate => rate.priceItemType?.uuid === priceItemType.uuid)
      : undefined

    return accessorialRate ?? initialAccessorialRate
  }

  const accessorialRate = accessorialType
    ? accessorialRates.find(rate => rate.type === accessorialType)
    : undefined

  return accessorialRate ?? initialAccessorialRate
}
